<div class="container-fluid">
  <div class="m-2">
    <button mat-raised-button color="accent" (click)="refreshData()">
      <fa-icon [icon]="faRecycle"></fa-icon>
      Refresh
    </button>
  </div>
  <mat-tab-group class="w-100">
    <mat-tab label="User Management">
      <dx-data-grid id="usersGrid"
                    [dataSource]="usersDataSource"
                    [remoteOperations]="true"
                    [allowColumnReordering]="true"
                    [rowAlternationEnabled]="true"
                    [showBorders]="true"
                    [columns]="userColumns"
                    [columnAutoWidth]="true"
                    [showScrollbar]="true"
                    [width]="'100%'"
                    (onSaving)="onUserGridSaving($event)"
                    (onContentReady)="onUsersGridReady($event)">
        <dxo-editing mode="batch"
                     [allowAdding]="true"
                     [allowDeleting]="true"
                     [allowUpdating]="true"></dxo-editing>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
        <div *dxTemplate="let item of 'detail'">
          <app-admin-user-detail [data]="item"></app-admin-user-detail>
        </div>
      </dx-data-grid>
    </mat-tab>
    <mat-tab label="Task Configuration">
      <dx-data-grid id="tasksGrid"
                    [dataSource]="taskSettingsDataSource"
                    [remoteOperations]="true"
                    [allowColumnReordering]="true"
                    [rowAlternationEnabled]="true"
                    [showScrollbar]="true"
                    [showBorders]="true"
                    [columns]="taskSettingsColumns"
                    [columnAutoWidth]="true"
                    [width]="'100%'"
                    (onSaving)="onTaskSettingsGridSaving($event)">
        <dxo-editing mode="batch"
                     [allowAdding]="true"
                     [allowDeleting]="true"
                     [allowUpdating]="true"></dxo-editing>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
      </dx-data-grid>
    </mat-tab>
    <mat-tab label="Email Configuration">
      <dx-data-grid id="emailGrid"
                    [dataSource]="emailConfigurationDataSource"
                    [remoteOperations]="true"
                    [allowColumnReordering]="true"
                    [rowAlternationEnabled]="true"
                    [showScrollbar]="true"
                    [columns]="emailConfigurationColumns"
                    [showBorders]="true"
                    [columnAutoWidth]="true"
                    [width]="'100%'"
                    (onSaving)="onEmailSettingsGridSaving($event)">
        <dxo-editing mode="batch"
                     [allowAdding]="true"
                     [allowDeleting]="true"
                     [allowUpdating]="true"></dxo-editing>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
      </dx-data-grid>
    </mat-tab>
    <mat-tab label="Plugins Configuration">
      <dx-data-grid id="pluginsGrid"
                    [dataSource]="pluginsDataSource"
                    [showScrollbar]="true"
                    [remoteOperations]="true"
                    [allowColumnReordering]="true"
                    [rowAlternationEnabled]="true"
                    [showBorders]="true"
                    [columns]="pluginsColumns"
                    [columnAutoWidth]="false"
                    [width]="'100%'"
                    (onSaving)="onPluginsGridSaving($event)">
        <dxo-editing mode="batch"
                     [allowAdding]="true"
                     [allowDeleting]="true"
                     [allowUpdating]="true"></dxo-editing>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
        <div *dxTemplate="let item of 'detail'">
          <app-admin-plugin-detail (saveGridEvent)="onPluginsGridSaving($event)" [data]="item"></app-admin-plugin-detail>
        </div>
      </dx-data-grid>
    </mat-tab>
  </mat-tab-group>
</div>
